module.exports = __webpack_public_path__ + "static/media/top-banner.4e979e7b.png";